import React, { useState, Fragment } from 'react'
import { IRadioValue } from '../types.d'

type FieldValues = {
  name: string, 
  label: string,
  error: any, 
  inputRef: any, 
  defaultValue: any,
  options: Array<IRadioValue>,
  onChange: any
};

const FieldRadioGroup: React.FC<FieldValues> = ({ name, label, error, inputRef, defaultValue, options, onChange }) => {
  const [fieldValue, setFieldValue] = useState(defaultValue);
  const handleChange = (e: any) => {
    setFieldValue(e.target.value);
    onChange(e);
  }
  return (
    <Fragment>
      <div className='i-form-group'>
        <label id={`${name}-desc`} className="i-form-desc">{label}</label>
        <div className="i-radio-holder">
          {options.map((o,i) => 
            <Fragment key={i}>
              <input type='radio'
                name={name}
                id={`${name}-${i}`}
                ref={inputRef}
                value={o.value}
                aria-describedby={`${name}-desc`}
                onChange={handleChange}
                defaultChecked={defaultValue == o.value}
              />
              <label htmlFor={`${name}-${i}`}>{o.label}</label>
            </Fragment>
          )}
        </div>
        {error ? <div className="i-form-group-text i-has-error">
          {typeof error === 'string' ? error : `This is required`}
        </div> : ''}
      </div>
    </Fragment>
  )
}

export default FieldRadioGroup
